import { AppData, Lightning } from "@lightningjs/sdk";
import { Helper } from "../lib/helper";
import { AppSetup } from "../lib/app-setup";
import { AppApiConfig } from "../lib/app-api-config";

export class CloseButton extends Lightning.Component {
    textfocuscolor: any;

    static override _template() {
        return {
            w: (w) => w,
            h: (h) => h,
            rect: true,
            color: 0xffffffff,
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 4 },
            flex: { direction: 'row', alignItems: 'flex-end', justifyContent: 'center' },
            Text: { text: {text: "CLOSE",  fontSize: 32, textColor: 0xff000000, textAlign: 'center', fontFace: Helper.getFontFamily('Regular')} }
        };
    }

    override _active() {
        const { appState } = AppData as AppSetup;
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        this.textfocuscolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)
    }

    override _focus() {
        this.patch({
            color: this.textfocuscolor,
            Text: { text: { textColor: 0xffffffff } }
        });
    }

    override _unfocus() {
        this.patch({
            color: 0xffffffff,
            Text: { text: { textColor: 0xff000000 } }
        });
    }
}